import { Outlet, useNavigate } from 'react-router-dom';
import {
  selectAuth,
  selectIsCancelLogin,
  selectIsLoggingIn
} from '../../ducks/auth';

import Loader from '../Loader/Loader';
import LoginModal from '../../pages/root/LoginModal';
import { selectLocalSettings } from '../../ducks/settings';
import { useSelector } from 'react-redux';
import { useSetState } from 'react-use';

const PrivateRoute = () => {
  const auth = useSelector(selectAuth);
  const isLoggingIn = useSelector(selectIsLoggingIn);
  const isCancelLogin = useSelector(selectIsCancelLogin);
  const navigate = useNavigate();
  const locale = useSelector(selectLocalSettings);
  const [loginModal, setLoginModal] = useSetState({
    open: true
  });

  const onCloseLoginModal = () => {
    setLoginModal({ open: false });
    navigate(`/${locale}`);
  };

  if (isLoggingIn && !isCancelLogin)
    return (
      <div className="page">
        <div className="container">
          <div className="loader-page">
            <Loader className="lds-black lds-large" />
          </div>
        </div>
      </div>
    );

  return auth.ticket ? (
    <Outlet />
  ) : (
    <div className="container">
      <LoginModal open={loginModal.open} onClose={onCloseLoginModal} />
      <div className="loader-page">
        <Loader className="lds-black lds-large" />
      </div>
    </div>
  );
};

export default PrivateRoute;
